{
  "app.name": "studio",
  "app.tagline": "NovaTechnica platform — super-admin console + agency owner UI",
  "nav.home": "Home",
  "nav.login": "Sign in",
  "nav.logout": "Sign out",
  "nav.account": "Account",
  "lang.switcher.label": "Language",
  "lang.fr": "Français",
  "lang.en": "English",
  "loading": "Loading…",
  "error.generic": "Something went wrong.",
  "error.network": "Could not reach the server.",
  "error.unauthorized": "You are not signed in."
}
